import { render, staticRenderFns } from "./DistributorsFilter.vue?vue&type=template&id=0c84529a&scoped=true"
import script from "./DistributorsFilter.vue?vue&type=script&lang=js"
export * from "./DistributorsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84529a",
  null
  
)

export default component.exports